import {useStore} from '@/store';
import {Commit} from 'vuex';
import {APP_MODULE} from '@/store/state';
import {ItineraryPreferencesState, itineraryPreferencesInitialState} from './itinerary-preferences-types';
import {fetchItineraryPreferences, updateItineraryPreferences} from './itinerary-preferences-api';
import {getUserId} from '@/services/auth-shared';
import {getSessionId} from '@/store/state/helpers';

const MODULE_NAME = 'ITINERARY_PREFERENCES';

const Getters = {
  GET: `${MODULE_NAME}/GET`,
};

const Actions = {
  FETCH: `${MODULE_NAME}/FETCH`,
  SAVE: `${MODULE_NAME}/SAVE`,
};

const Mutations = {
  SET: `${MODULE_NAME}/SET`,
};

const store = useStore();

export const ItineraryPreferencesModule = {
  get: (): ItineraryPreferencesState => {
    return store.getters[`${APP_MODULE}/${Getters.GET}`];
  },

  fetch: () => {
    return store.dispatch(`${APP_MODULE}/${Actions.FETCH}`, {userId: getUserId(), sessionId: getSessionId()});
  },

  save: (preferences: ItineraryPreferencesState) => {
    return store.dispatch(`${APP_MODULE}/${Actions.FETCH}`, {
      userId: getUserId(),
      sessionId: getSessionId(),
      preferences,
    });
  },

  state: itineraryPreferencesInitialState,

  getters: {
    [Getters.GET]: (state: ItineraryPreferencesState): ItineraryPreferencesState => {
      return state;
    },
  },

  actions: {
    [Actions.FETCH]: async ({commit}: {commit: Commit}, payload: {userId: string; sessionId: string}) => {
      try {
        const preferences = await fetchItineraryPreferences(payload.userId, payload.sessionId);
        if (preferences) {
          commit(Mutations.SET, preferences);
          return preferences;
        }
        return [];
      } catch (e) {
        console.error('ItineraryPreferencesModule: failed to fetch POI', e);
      }
    },

    [Actions.SAVE]: async (
      {commit}: {commit: Commit},
      {userId, sessionId, preferences}: {userId: string; sessionId: string; preferences: ItineraryPreferencesState},
    ) => {
      try {
        const result = await updateItineraryPreferences(userId, sessionId, preferences);

        if (result) {
          commit(Mutations.SET, result);
          return result;
        }
        return [];
      } catch (e) {
        console.error('ItineraryPreferencesModule: failed to fetch POI', e);
      }
    },
  },
  mutations: {
    [Mutations.SET]: (state: ItineraryPreferencesState, preferences: ItineraryPreferencesState) => {
      state = {...preferences};
    },
  },
};
